import PaymentLoan from '~/assets/payment-loan.svg'
import PaymentCard from '~/assets/payment-card.svg'
import PaymentPaypay from '~/assets/payment-paypay.svg'
import PaymentBank from '~/assets/payment-bank.svg'
import type { EnabledPaymentMethodsEnumKey } from '~/types/api/_atoms/EnabledPaymentMethods'

// FieldEnum: アプリ内部のキー (camelCase)。テンプレート分岐や OrderEntry.selectedPaymentMethod の値域。
export enum FieldEnum {
  loanJaccs = 'loanJaccs',
  creditCard = 'creditCard',
  paypay = 'paypay',
  loanAplus = 'loanAplus',
  payeasy = 'payeasy',
}

// ValueEnum: ワイヤフォーマット (kebab-case)。Store.enabled_payment_methods や決済 API の wire 値。
// 値域は kubb の EnabledPaymentMethodsEnumKey (spec) と一致しなければならない。
// 下の _ValueEnumWireCheck で satisfies しているため spec から該当値が消えた場合は typecheck で落ちる。
export enum ValueEnum {
  loanJaccs = 'loan-jaccs',
  creditCard = 'credit-card',
  paypay = 'paypay',
  loanAplus = 'loan-aplus',
  payeasy = 'payeasy',
}

// FieldEnum と ValueEnum の対応表。アプリ内部キー -> wire の双方向変換と spec 整合の単一の根拠。
export const FieldEnumToValueEnum = {
  loanJaccs: ValueEnum.loanJaccs,
  creditCard: ValueEnum.creditCard,
  paypay: ValueEnum.paypay,
  loanAplus: ValueEnum.loanAplus,
  payeasy: ValueEnum.payeasy,
} as const satisfies Record<keyof typeof FieldEnum, EnabledPaymentMethodsEnumKey>

export interface sortedPaymentMethods {
  creditCard: boolean
  loanJaccs: boolean
  loanAplus: boolean
  payeasy: boolean
  paypay: boolean
}

export interface PaymentMethodItem {
  field: FieldEnum
  label: string
  value: ValueEnum
  icon?: string
}

const data = [
  {
    field: 'loanJaccs',
    label: '治療費分割払い',
    value: 'loan-jaccs',
    icon: PaymentLoan,
  },
  {
    field: 'creditCard',
    label: 'クレジットカード',
    value: 'credit-card',
    icon: PaymentCard,
  },
  {
    field: 'paypay',
    label: 'PayPay',
    value: 'paypay',
    icon: PaymentPaypay,
  },
  {
    field: 'creditCard',
    label: 'クレジットカード',
    value: 'credit-card',
    icon: PaymentCard,
  },
  {
    field: 'loanAplus',
    label: '治療費分割払い',
    value: 'loan-aplus',
    icon: PaymentLoan,
  },
  {
    field: 'payeasy',
    label: '口座引き落とし',
    value: 'payeasy',
    icon: PaymentBank,
  },
] as PaymentMethodItem[]

export const PaymentMethod = {
  ...data,

  getLabelByField(field: string) {
    const entry = data.find((obj) => obj.field === field)
    return entry ? entry.label : ''
  },

  getItemByField(field: string) {
    const entry = data.find((obj) => obj.field === field) ?? ({} as PaymentMethodItem)
    return entry
  },
}

export const sortEnabledPaymentMethods = (targets: readonly string[]) => {
  // ValueEnum / kubb の EnabledPaymentMethodsEnumKey はどちらも同じ wire
  // 文字列 (例 'credit-card') を表すため string[] で受ける。
  return {
    creditCard: targets.includes(ValueEnum.creditCard),
    loanJaccs: targets.includes(ValueEnum.loanJaccs),
    loanAplus: targets.includes(ValueEnum.loanAplus),
    payeasy: targets.includes(ValueEnum.payeasy),
    paypay: targets.includes(ValueEnum.paypay),
  } as sortedPaymentMethods
}
